import { RoomType } from "@supernova-studio/model";
export class ForgeProjectDocument {
    constructor(model) {
        var _a, _b, _c, _d, _e;
        this.id = model.id;
        this.title = model.title;
        this.iterationId = (_a = model.iterationId) !== null && _a !== void 0 ? _a : null;
        this.previewUrl = (_b = model.previewUrl) !== null && _b !== void 0 ? _b : null;
        this.projectId = model.projectId;
        this.createdAt = new Date(model.createdAt);
        this.createdByUserId = model.createdByUserId;
        this.updatedAt = new Date(model.updatedAt);
        this.sectionId = (_c = model.sectionId) !== null && _c !== void 0 ? _c : null;
        this.sortOrder = model.sortOrder;
        this.roomId = `${RoomType.ForgeProjectArtifact}:${model.projectId}:${model.id}`;
        this.threadId = model.threadId;
        this.thumbnailUrl = (_e = (_d = model.thumbnail) === null || _d === void 0 ? void 0 : _d.url) !== null && _e !== void 0 ? _e : undefined;
        this.isArchived = model.isArchived;
    }
    toRemote() {
        var _a, _b;
        return {
            ...this,
            sectionId: (_a = this.sectionId) !== null && _a !== void 0 ? _a : undefined,
            createdAt: this.createdAt.toISOString(),
            updatedAt: (_b = this.updatedAt) === null || _b === void 0 ? void 0 : _b.toISOString(),
        };
    }
}
